import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'account-orders-details-items-item-extra-fields',
    templateUrl: './account.orders.details.items.item.extra-fields.component.html',
    styleUrls: ['./../../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsItemsItemExtraFieldsComponent {
    @Input('extraFields') extraFields;
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/account/orders/details/items/item/extra-fields/account.orders.details.items.item.extra-fields.component.ts